import { render, staticRenderFns } from "./changeNickName.vue?vue&type=template&id=0c1555bf&scoped=true&"
import script from "./changeNickName.vue?vue&type=script&lang=js&"
export * from "./changeNickName.vue?vue&type=script&lang=js&"
import style0 from "./changeNickName.vue?vue&type=style&index=0&id=0c1555bf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1555bf",
  null
  
)

export default component.exports